import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import EmailNotificationEvidencePanel from './EmailNotificationEvidencePanel';

const ReportPanels = ({
  panels,
  reportId,
  runtimeFilters,
  emailNotificationEvidence,
  loading,
  onEmailEvidenceNextPage,
  onEmailEvidenceError,
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
      <Stack spacing={1}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Panels
        </Typography>
        {panels.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No panels configured for this report.
          </Typography>
        ) : (
          <Stack spacing={1}>
            {panels.map((panel) =>
              panel.type === 'email_notification_evidence' &&
              panel?.params?.dataset === 'email_sends' &&
              Number(panel?.params?.contractVersion) === 1 ? (
                <EmailNotificationEvidencePanel
                  key={panel.id || panel.type}
                  reportId={reportId}
                  runtimeFilters={runtimeFilters}
                  evidence={emailNotificationEvidence}
                  loading={loading}
                  onNextPage={onEmailEvidenceNextPage}
                  onError={onEmailEvidenceError}
                />
              ) : (
                <Paper key={panel.id || panel.type} variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {panel.params?.label || panel.type}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Panel type: {panel.type}
                  </Typography>
                </Paper>
              )
            )}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
};

export default ReportPanels;
